import { render, staticRenderFns } from "./PerBranch.vue?vue&type=template&id=78c31dca"
import script from "./PerBranch.vue?vue&type=script&lang=js"
export * from "./PerBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports